<template>

    <div class="timezone-wrap noEdit">
      <div class="content--header">
        <span class="header-icon">
          <i class="icon icon--warning-red-polygon"></i>
        </span>
        <strong>{{ $t('timezone.dialogNoEdit.title') }}</strong>
      </div>
      <div class="content--body">
        <div class="info">
          <ul class="main">
            <li>
              <span class="timezone-title" v-html="$t('timezone.timezoneChange.mainDomain')"></span>
              <span class="timezone-value">*.{{ domain }}</span>
            </li>
            <li>
              <span class="timezone-title" v-html="$t('timezone.timezoneChange.timezoneTitle')"></span>
              <span class="timezone-value">({{timezone}}) {{timezoneName}}</span>
            </li>
          </ul>
        </div>

        <div class="desc">
          <p v-html="$t('timezone.dialogNoEdit.desc')"></p>
        </div>

        <div class="buttons">
          <ui-button primary2 @click="onSubmit">{{ $t('common.ok') }}</ui-button>
        </div>
      </div>
    </div>
</template>

<script>
import UiButton from '@/components/ui/UiButton.vue'
import { getOffset } from '@/libs/utils'

export default {
  name: 'TimezoneNoEdit',
  components: { UiButton },
  props: [
    'domain',
    'timezoneName'
  ],
  computed: {
    timezone () {
      return getOffset(this.timezoneName)
    }
  },
  methods: {
    async onSubmit () {
      this.$emit('check', true)
    }
  }
}
</script>

<style lang="scss">
.dimmed {
  & .timezone-wrap {
    width: 430px;
    border-radius: 14px;
    box-shadow: 0 8px 15px 0 rgba(0, 0, 0, 0.16), 0 0 0 1px rgba(0, 0, 0, 0.16);
    background-color: #ffffff;
    padding-top: 50px;
    padding-bottom: 25px;
    text-align: center;
    @include positionXYcenter;

    &.noEdit {
      .content--body {
        padding: 0 30px;
        margin-top: 25px;

        & .desc {
          font-size: 14px;
          line-height: 1.43;
          text-align: center;
          color: #2f2f2f;
          margin-bottom: 40px;
          & p {
            word-break: keep-all;
          }
        }
      }
    }

    & .content--header {
      & .header-icon {
        display:block;
      }
      & strong {
        padding-top: 12px;
        display: block;
        font-size: 20px;
        font-weight: 500;
        line-height: 1.3;
        color: #444;
      }

    }

    .content--body {
      padding: 0px 20px 0 20px;

      & .info {
        width: 330px;
        border: solid 1px #d7d7d7;
        border-radius: 6px;
        background-color: #f4f4f4;
        padding: 20px;
        margin-bottom: 25px;
        font-size: 14px;
        line-height: 1.43;

        ul.main {

          & li {
            text-align: left;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0px;
            }
            & > .timezone-title {
              min-width: 100px;
              display: inline-block;
              overflow: hidden;
              color: #666;
              vertical-align: top;
            }

            & > .timezone-value {
              display: inline-block;
              color: #2f2f2f;
              width: calc(100% - 100px);
              overflow: hidden;
              text-overflow: ellipsis;
              word-break: break-all;
            }
          }
        }
      }

      & .select__timezone--wrap {
        padding: 25px 10px 25px 10px;

        & label {
          display: block;
          text-align: left;
          font-size: 14px;
          font-weight: 500;
          color: #767676;
          padding-left: 5px;
          margin-bottom: 5px;
        }

        & .ui_select {
          width: 370px;
          & .selected-item {
            height: 38px;
          }

        }
      }

      & .desc {
        padding: 0 30px 0 45px;

        & ul {
          list-style: square;

          li {
            text-align: left;
            font-size: 14px;
            line-height: 1.43;
            color: #2f2f2f;
            padding-bottom: 12px;

            & .highlight {
              color: #ec0047;
            }
          }
        }
      }

      & .agree {
        padding: 25px 30px 40px 30px;
        text-align: left;

        .terms-agree {
          position: relative;
          top: 1px;
        }

        .ui_checkbox {
          margin-left: 0px;
        }
      }

      & .buttons {
        & .btn__cancel {
          margin-right: 5px;
        }
      }
    }
  }
}

</style>
